<div class="cigna-error">
  <cigna-icon [type]="icon"></cigna-icon
  ><span class="{{ containerClass }}" [innerHTML]="description"></span>
</div>
